module.exports = __webpack_public_path__ + "static/media/1-godt.1b8459a1.mp3";